var _title, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCustomerService = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "13px",
    viewBox: "0 0 13 13",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "globe")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BITACore-Resources-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1214.000000, -15.000000)",
    id: "Group-58"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1129.000000, 12.061433)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Log-Out-Copy-3",
    transform: "translate(84.000000, 0.938567)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outlined-/-Action-/-help_outline",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 14.2757937 0 14.2757937 14.39 0 14.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.54307209,10.7925 L7.73272156,10.7925 L7.73272156,9.59333333 L6.54307209,9.59333333 L6.54307209,10.7925 Z M7.13789683,1.19916667 C3.85446429,1.19916667 1.18964947,3.8853 1.18964947,7.195 C1.18964947,10.5047 3.85446429,13.1908333 7.13789683,13.1908333 C10.4213294,13.1908333 13.0861442,10.5047 13.0861442,7.195 C13.0861442,3.8853 10.4213294,1.19916667 7.13789683,1.19916667 Z M7.13789683,11.9916667 C4.51471974,11.9916667 2.37929894,9.8391625 2.37929894,7.195 C2.37929894,4.5508375 4.51471974,2.39833333 7.13789683,2.39833333 C9.76107391,2.39833333 11.8964947,4.5508375 11.8964947,7.195 C11.8964947,9.8391625 9.76107391,11.9916667 7.13789683,11.9916667 Z M7.13789683,3.5975 C5.82333416,3.5975 4.75859788,4.67075417 4.75859788,5.99583333 L5.94824735,5.99583333 C5.94824735,5.33629167 6.48358962,4.79666667 7.13789683,4.79666667 C7.79220403,4.79666667 8.3275463,5.33629167 8.3275463,5.99583333 C8.3275463,7.195 6.54307209,7.04510417 6.54307209,8.99375 L7.73272156,8.99375 C7.73272156,7.6446875 9.51719577,7.49479167 9.51719577,5.99583333 C9.51719577,4.67075417 8.45245949,3.5975 7.13789683,3.5975 Z",
    id: "\\uD83D\\uDD39-Icon-Color",
    fill: "#FFFFFF"
  }))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCustomerService, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/customer-service.01e72916.svg";
export { ForwardRef as ReactComponent };